import React, { Component } from "react";
import { Button } from "react-bootstrap";
import ReactTable from "react-table";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faEdit } from "@fortawesome/free-solid-svg-icons";

export default class TBLHorarios extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      pages: 0,
      page: 0,
      limit: 10,
      loading: false,
    };

    this.columns = [
      {
        Header: "Dia da semana",
        accessor: "desc_dia",
        className: "center",
      },
      {
        Header: "Agendamento disponível",
        accessor: "entrega_agendada_ativa",
        Cell: (props) => <span>{props.value ? "Sim" : "Não"}</span>,
        className: "center",
      },
      {
        Header: "Entrega expressa disponível",
        accessor: "entrega_expressa_ativa",
        Cell: (props) => <span>{props.value ? "Sim" : "Não"}</span>,
        className: "center",
      },
      {
        Header: "Entrega programada disponível",
        accessor: "entrega_programada_ativa",
        Cell: (props) => <span>{props.value ? "Sim" : "Não"}</span>,
        className: "center",
      },
      {
        Header: "Horários",
        accessor: "horarios",
        Cell: (props) =>
          Array.isArray(props.value) && props.value.length ? (
            props.value.map((hora, i) => (
              <span key={i}>
                {" "}
                {hora ? hora.hora_inicio : ""}h às {hora ? hora.hora_fim : ""}h
                /
              </span>
            ))
          ) : (
            <span>-</span>
          ),
        className: "center",
      },
      {
        Header: "Ações",
        Cell: (row) => {
          return (
            <div>
              <Button
                size="sm"
                style={{ marginRight: 4 }}
                onClick={() => this.gerenciarAcoes("editar", row.row._original)}
              >
                <FontAwesomeIcon icon={faEdit}></FontAwesomeIcon>
              </Button>
              <Button
                size="sm"
                variant="danger"
                onClick={() =>
                  this.gerenciarAcoes("deletar", row.row._original)
                }
              >
                <FontAwesomeIcon icon={faTrash}></FontAwesomeIcon>
              </Button>
            </div>
          );
        },
        className: "center",
      },
    ];
  }

  gerenciarAcoes = (tipo, dados) => {
    if (tipo === "deletar") {
      this.props.dataCallback(tipo, dados);
    } else if (tipo === "editar") {
      this.props.dataCallback(tipo, dados);
    } else {
      return;
    }
  };

  render() {
    return (
      <ReactTable
        data={this.props.data}
        columns={
          this.props.showAcoes ? [...this.columns, ...this.acoes] : this.columns
        }
        className="-striped -highlight"
        showPagination={false}
        defaultPageSize={7}
        previousText="Anterior"
        nextText="Próximo"
        loadingText="Carregando métodos..."
        noDataText="Nenhum horário encontrado!"
        pageText="Página"
        ofText="de"
        rowsText="linhas"
      />
    );
  }
}

TBLHorarios.propTypes = {
  data: PropTypes.array,
  dataCallback: PropTypes.func,
  showAcoes: PropTypes.bool,
};
